<template>
    <div class="uk-flex uk-flex-between">
        <div
            class="uk-text-primary"

        >
            <button
                class="uk-button uk-button-primary uk-button-small"
                type="button"

                :disabled="isAjaxing || ignoreCheck"
                @click.stop="check"
            >
                <span>
                    <i class="material-icons">search</i>
                    개인통관고유부호 검사
                </span>
            </button>
        </div>




    </div>
</template>

<script>
    export default {
        props: {
            /**
             * 수취인명
             */
            name: {
                type: String,
                default: null,
            },
            /**
             * 핸드폰
             */
            cell: {
                type: String,
                default: null,
            },
            /**
             * 개인통관고유부호
             */
            clearanceNo: {
                type: String,
                default: null,
            },
            /**
             * 우편번호
             */
            zipcode: {
                type: String,
                default: null,
            },
            /**
             * 영문 이름
             */
            firstName: {
                type: String,
                default: null,
            },
            /**
             * 영문 성
             */
            lastName: {
                type: String,
                default: null,
            },

            // csrf-token
            csrfToken: String,

            // 로그인 ID
            loginUserId: {
                type: Number,
                default: null
            },

            // 로그인 닉네임
            loginUserNick: {
                type: String,
                default: null
            },
        },
        data: function () {
            return {
                /**
                 * (bool)
                 * 검사무시여부
                 *  - true : 검사안함
                 *  - false : 검사함
                 */
                ignoreCheck: false,

                /**
                 * (bool)
                 * ajax 실행여부
                 */
                isAjaxing: false,

                /**
                 * (string)
                 * 마지막으로 검증한 ajax 검증결과
                 *  - 'correct' : 일치
                 *  - 'incorrect' : 불일치 or 통신실패
                 */
                latelyResult: null,

                /**
                 * (string)
                 * 마지막 검증에 사용된 수취인명
                 */
                latelyName: null,

                /**
                 * (string)
                 * 마지막 검증에 사용된 핸드폰
                 */
                latelyCell: null,

                /**
                 * (string)
                 * 마지막 검증에 사용된 개인통관고유부호
                 */
                latelyClearanceNo: null,

                /**
                 * (string)
                 * 마지막 검증 response
                 */
                latelyHttpResponse: null,


            };
        },
        computed: {
            /**
             * 검증상태
             *
             * @return (string)
             *          'none' : 정보 미입력
             *          'need' : 검증필요
             *          'corrected' : 검증성공(일치)
             *          'incorrected' : 검증실패(불일치)
             */
            checkState() {
                let clearance_no = _.trim(this.clearanceNo);
                if (! clearance_no) {
                    return 'none';
                }

                let cell = _.trim(this.cell);
                if (! cell) {
                    return 'none';
                }

                // 마지막 검증정보와 불일치
                if (this.latelyName !== this.name
                    || this.latelyCell !== this.cell
                    || this.latelyClearanceNo !== this.clearanceNo
                ) {
                    return 'need';
                }

                if (this.latelyResult === 'correct') {
                    return 'corrected';
                } else if (this.latelyResult === 'incorrect') {
                    return 'incorrected';
                }

                // 한번도 검증안해서 null 인 경우
                return 'need';
            },

            /**
             * 개인통관고유부호 검증결과
             * - 개인통관고유부호 미입력으로 검증이 불필요해도 true 반환
             * - 검사안함 설정된경우, true반환
             *
             * @return (bool) true : 통과(일치) , false : 불일치
             */
            isCorrect() {
                if (this.ignoreCheck) {
                    return true;
                }

                return this.checkState === 'none'
                    || this.checkState === 'corrected';
            },

            /**
             * 불일치 메세지
             *
             * @return string
             */
            incorrectMsg() {
                if (! this.latelyHttpResponse) {
                    return null;
                }

                if (this.latelyHttpResponse.msg) {
                    return this.latelyHttpResponse.msg;
                }

                return this.latelyHttpResponse;

            },
        },
        watch: {

            checkState: function (val) {
                this.$emit('update-check-state', val);
            },

            incorrectMsg: function (val) {
                this.$emit('update-incorrect-msg', val);
            },
        },
        methods: {
            /**
             * 검증 ajax 실행
             */
            check() {
                // 이미 실행중인지 검사
                if (this.isAjaxing) {
                    alert('이미 검사가 진행중입니다. 잠시만 기다려주세요.');
                    return;
                }
                this.isAjaxing = true;

                // promise 생성
                let data = {
                    //_token: this.csrfToken,
                    cell: this.cell,
                    clearance_no: this.clearanceNo,
                    name: this.name,
                    zipcode: this.zipcode,
                    first_name: this.firstName,
                    last_name: this.lastName,

                    user_id: this.loginUserId,
                    user_nick: this.loginUserNick,
                };
                let load = new Promise((resolve, reject) => {
                    // ajax 옵션
                    let opts = {
                        type: 'post',
                        url: 'https://api.global.gonelo.com/check-clearance-no/ver2026',
                        data: data,
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject(textStatus + ' / ' + errorThrown);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.latelyResult = response.is_correct ? 'correct' : 'incorrect';
                    this.latelyHttpResponse = response;

                }).catch((err) => {
                    //console.log(err);
                    this.latelyResult = 'incorrect';
                    this.latelyHttpResponse = err;
                }).finally(() => {
                    this.isAjaxing = false;
                    this.latelyName = data.name;
                    this.latelyClearanceNo = data.clearance_no;
                    this.latelyCell = data.cell;
                });
            },

        },
    }
</script>

<style lang="scss" scoped>
</style>